import { DOCUMENT_METADATA } from '~/constants/conversationModels';
import { keyBy, map, merge } from 'lodash';

// create a new object that maps the label-value key pairs
const mapMetadataFields = (metadataDocument) =>
  Object.entries(DOCUMENT_METADATA)
    .filter(([key]) => Object.keys(metadataDocument).includes(key))
    .reduce((array, [key]) => {
      const newObj = {
        label: DOCUMENT_METADATA[key],
        value: metadataDocument[key],
      };

      return [...array, newObj];
    }, []);

export const getAllMetadataFields = (metadataDocument) => {
  const fields = mapMetadataFields(metadataDocument);
  const customFields = metadataDocument.customDisplayFields || [];
  return [...fields, ...customFields];
};

// merge metadata,thumbs, favoriteDocumentsIds preserving the order of the elements from the third one
export const mergeDocumentData = (metadata, thumbs, documentIds) => {
  const keyedArray1 = keyBy(metadata, 'externalId');
  const keyedArray2 = keyBy(thumbs, 'documentId');

  return map(documentIds, (id) => {
    return merge({}, keyedArray1[id], keyedArray2[id]);
  }).filter((doc) => Object.keys(doc).length > 0);
};
